import apiClient from '../../api/base/apiClient'

export interface AdminLoginRequest {
  username: string
  password: string
}

export interface AdminLoginResponse {
  message: string
  user: {
    username: string
    nickname: string
  }
  token: string
}

export const adminAuthApi = {
  login: async (data: AdminLoginRequest): Promise<AdminLoginResponse> => {
    const response = await apiClient.post<AdminLoginResponse>(
      '/admin/login',
      data
    )

    if (response.data.token) {
      localStorage.setItem('admin_token', response.data.token)
    }

    return response.data
  },
}
